import { render } from "./notification_filters.vue?vue&type=template&id=1f42343a"
import script from "./notification_filters.vue?vue&type=script&lang=js"
export * from "./notification_filters.vue?vue&type=script&lang=js"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__